import { BCSignature, findMessage } from '@bimser/components';
import { FormItemTypes, IDictionary } from '@bimser/core';
import { JSX } from 'react';
import { IPropertyField } from '../../../../entities/common';
import InputControl from '../../base/InputControl';
import Style from './assets/styles.scss';
import { ISignatureProperties } from './entities/ISignatureProperties';

export default class Signature extends InputControl<string> {
	height: number;
	width: number;
	dotSize: number;
	penColor: string;
	minPenSize: number;
	maxPenSize: number;
	showBorder: boolean;
	showLegalWarning: boolean;

	constructor() {
		super();

		this.onChange = this.onChange.bind(this);

		this.controlType = FormItemTypes.EControlTypes.Signature;
		this.width = 300;
		this.height = 150;
		this.dotSize = 2;
		this.minPenSize = 0.5;
		this.maxPenSize = 2.5;
		this.penColor = 'rgba(0, 0, 0, 1)';
		this.showBorder = true;
		this.showLegalWarning = true;

		this.subscribe('trigger:OnValueChanged', (value: string) => {
			this.onChange(value || null);
		});
	}

	__loadProperties(data: ISignatureProperties) {
		super.__loadProperties(data);

		this.__proxyChanged.height = data.height;
		this.__proxyChanged.width = data.width;
		this.__proxyChanged.dotSize = data.dotSize;
		this.__proxyChanged.penColor = data.penColor;
		this.__proxyChanged.minPenSize = data.minPenSize;
		this.__proxyChanged.maxPenSize = data.maxPenSize;
		this.__proxyChanged.showBorder = data.showBorder;
		this.__proxyChanged.showLegalWarning = data.showLegalWarning;
	}

	__getComponentData(): IDictionary<any> {
		return {
			...super.__getComponentData(),
			width: this.width,
			height: this.height,
			dotSize: this.dotSize,
			minPenSize: this.minPenSize,
			maxPenSize: this.maxPenSize,
			penColor: this.penColor,
			showBorder: this.showBorder,
			showLegalWarning: this.showLegalWarning
		};
	}

	__getPropertyFields(): IPropertyField[] {
		return [
			...super.__getPropertyFields(),
			{
				name: 'width',
				type: 'number'
			},
			{
				name: 'height',
				type: 'number'
			},
			{
				name: 'dotSize',
				type: 'number'
			},
			{
				name: 'penColor',
				type: 'string'
			},
			{
				name: 'minPenSize',
				type: 'number'
			},
			{
				name: 'maxPenSize',
				type: 'number'
			},
			{
				name: 'showBorder',
				type: 'boolean'
			},
			{
				name: 'showLegalWarning',
				type: 'boolean'
			}
		];
	}

	private onChange(base64: string) {
		this.__proxyChanging.value = base64;
	}

	__render(): JSX.Element {
		return super.__render(
			<div className={Style.container}>
				<BCSignature
					backgroundColor={this.style.backgroundColor}
					disabled={this.__isDisabled()}
					readonly={this.__isReadOnly()}
					maxPenSize={this.maxPenSize}
					minPenSize={this.minPenSize}
					showBorder={this.showBorder}
					onChange={this.onChange}
					penColor={this.penColor}
					dotSize={this.dotSize}
					height={this.height}
					width={this.width}
					value={this.value}
				/>
				{this.showLegalWarning && (
					<span className={Style.legalWarning}>{findMessage.get('103059')}</span>
				)}
			</div>
		);
	}
}
